import Client from './Clients/AxiosClient'

export default {
  getMarketingImportSummary (data) {
    return Client.post('marketing/get_marketing_import_summary', data)
      .then(response => response.data)
  }
}
